import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import IconBadge from './icon-badge'

const TOOLTIP_TEXT =
  'Conflicts internal to the role. Any user assigned to this role will inherit the conflicts from this role.'

const InternalConflict = ({ count, textDisplay = '' }) => (
  <IconBadge
    icon={faExclamationTriangle}
    iconColor="text-danger"
    textColor="text-danger"
    tooltipText={TOOLTIP_TEXT}
    count={!textDisplay ? count : undefined}
    text={textDisplay || undefined}
  />
)

export default InternalConflict
